"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
export default function ReferralInformation() {
  const {
    ref: contentRef,
    isVisible: contentVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.2
  });
  return <section data-section-id="5200" id="how-to-refer" className="bg-background text-foreground pt-16 pb-32 md:pt-24 md:pb-50 px-6 md:px-12 overflow-hidden border-t border-border">
      <div className="max-w-7xl mx-auto">
        <div ref={contentRef} className={`max-w-3xl transition-all duration-700 ${contentVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <div className="flex flex-col gap-4 mb-8">
            <span className="font-mono text-xs md:text-sm tracking-widest uppercase text-primary font-bold">
              REFERRAL INFORMATION
            </span>
            <div className="h-px w-16 bg-primary" />
          </div>

          <h2 className="font-serif font-medium text-4xl md:text-5xl lg:text-6xl leading-tight mb-8">
            How to Refer a Patient
          </h2>

          <p className="text-lg md:text-xl text-muted-foreground mb-12 leading-relaxed">
            To refer a patient for pulmonary consultation or sleep medicine evaluation, please send clinical notes and patient demographics via fax or contact our office directly.
          </p>

          <div className="flex flex-col sm:flex-row gap-4">
            <Button size="lg" className="rounded-md px-8 py-6 text-base font-semibold">
              Fax Referral: (412) 533-5622
            </Button>
            <Link to="tel:+14126729240">
              <Button variant="outline" size="lg" className="rounded-md px-8 py-6 text-base font-semibold w-full sm:w-auto">
                Call Office: (412) 672-9240
              </Button>
            </Link>
          </div>
        </div>
      </div>
    </section>;
}